import React, { useState, useContext } from 'react'
import { UrlServicesContext } from 'components/UrlServicesContext'

import { withStyles, makeStyles } from '@material-ui/core/styles'
import {
  Button,
  Dialog,
  Grid,
  DialogContent,
  DialogActions,
  CircularProgress,
} from '@material-ui/core'
import { Cancel, VpnKey, LockOpen } from '@material-ui/icons'
import { Alert } from '@material-ui/lab'
import axios from 'axios'

import { cardBodyStyle } from 'assets/jss/material-dashboard-react/components/cardBodyStyle'

const useStyles = makeStyles(cardBodyStyle)

const MuiDialogContent = withStyles((theme) => ({
  root: { padding: theme.spacing(2) },
}))(DialogContent)

const MuiDialogActions = withStyles((theme) => ({
  root: { margin: 0, padding: theme.spacing(1) },
}))(DialogActions)

export default function JobPasswordVerify(props) {
  const classes = useStyles()
  const { urlServices, keyAplication } = useContext(UrlServicesContext)
  let keyAuthorization = localStorage.getItem('Session')

  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const handleChange = (e) => {
    const val = e.target.value.replace(/\D/g, '').slice(0, 4)
    setPassword(val)
    setError('')
  }

  const handleVerify = async () => {
    if (password.length !== 4) {
      setError('Ingresa los 4 dígitos de la clave.')
      return
    }

    setLoading(true)
    setError('')

    try {
      const res = await axios.get(
        `${urlServices}job-passwords/job/${props.jobId}`,
        {
          headers: {
            application: keyAplication,
            Authorization: 'Bearer ' + keyAuthorization,
          },
        }
      )

      const activePassword = res.data.active

      if (!activePassword) {
        setError('Este cargo no tiene clave activa. Contacta al administrador.')
        setLoading(false)
        return
      }

      if (activePassword.password === password) {
        // Clave correcta — abrir la prueba
        props.onSuccess()
      } else {
        setError('Clave incorrecta. Intenta nuevamente.')
      }
    } catch (e) {
      setError('Error al verificar la clave. Intenta más tarde.')
    } finally {
      setLoading(false)
    }
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') handleVerify()
  }

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={props.open}
      onClose={props.exit}
      PaperProps={{ classes: { root: classes.DialogStyle } }}
    >
      <MuiDialogContent dividers>
        <Grid container spacing={2}>
          {/* Título */}
          <Grid item xs={12}>
            <div className={classes.titleCardFilter}>
              <VpnKey style={{ marginRight: 8, verticalAlign: 'middle' }} />
              Clave de acceso
            </div>
            <div className={classes.lineBottom}></div>
          </Grid>

          {/* Info cargo */}
          <Grid item xs={12}>
            <center>
              <div style={{ fontSize: 13, color: '#555', marginBottom: 8 }}>
                Para iniciar la prueba del cargo:
              </div>
              <div
                style={{
                  fontSize: 15,
                  fontWeight: 'bold',
                  color: '#024242',
                  padding: '6px 16px',
                  background: 'rgb(255, 244, 229)',
                  borderRadius: 8,
                  display: 'inline-block',
                }}
              >
                {props.jobName}
              </div>
              <div style={{ fontSize: 13, color: '#555', marginTop: 12 }}>
                Ingresa la clave de 4 dígitos proporcionada por el administrador:
              </div>
            </center>
          </Grid>

          {/* Input clave */}
          <Grid item xs={12}>
            <center>
              <input
                type="password"
                inputMode="numeric"
                maxLength={4}
                value={password}
                onChange={handleChange}
                onKeyPress={handleKeyPress}
                autoFocus
                style={{
                  fontSize: 36,
                  fontWeight: 'bold',
                  letterSpacing: 16,
                  textAlign: 'center',
                  width: 160,
                  padding: '10px 16px',
                  border: error
                    ? '2px solid #d32f2f'
                    : '2px solid rgb(224, 224, 224)',
                  borderRadius: 10,
                  outline: 'none',
                  background: '#fafafa',
                }}
                placeholder="••••"
              />
            </center>
          </Grid>

          {/* Error */}
          {error && (
            <Grid item xs={12}>
              <Alert severity="error" style={{ fontSize: 12 }}>
                {error}
              </Alert>
            </Grid>
          )}

          {/* Botón verificar */}
          <Grid item xs={12}>
            <center>
              <Button
                variant="contained"
                style={{
                  background: '#024242',
                  color: '#fff',
                  fontWeight: 'bold',
                  minWidth: 140,
                }}
                startIcon={
                  loading ? (
                    <CircularProgress size={16} style={{ color: '#fff' }} />
                  ) : (
                    <LockOpen />
                  )
                }
                onClick={handleVerify}
                disabled={loading || password.length !== 4}
              >
                {loading ? 'Verificando...' : 'Ingresar'}
              </Button>
            </center>
          </Grid>
        </Grid>
      </MuiDialogContent>
      <MuiDialogActions>
        <Button onClick={props.exit}>
          <Cancel />
        </Button>
      </MuiDialogActions>
    </Dialog>
  )
}